import * as tslib_1 from "tslib";
import * as React from 'react';
import { Toggle } from 'office-ui-fabric-react/lib';
import * as actions from '../actions/advertisingOptionsActions';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import OptionDescription from 'owa-options-controls/lib/components/OptionDescription';
import getOptions from '../selectors/getOptions';
var styles = require('./AdvertisingOptionFull.scss');
var AdvertisingOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(AdvertisingOptionFull, _super);
    function AdvertisingOptionFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdvertisingOptionFull.prototype.render = function () {
        var _a = getOptions(), allowAccess = _a.allowAccess, allowAdSelection = _a.allowAdSelection, allowContentSelection = _a.allowContentSelection, allowPersonalization = _a.allowPersonalization, allowMeasurement = _a.allowMeasurement;
        return (React.createElement("div", { className: styles.container },
            React.createElement("section", null,
                React.createElement("header", { className: styles.title }, strings.option_ads_heading_learn_more),
                React.createElement(OptionDescription, null, strings.option_ads_description_learn_more)),
            React.createElement("section", null,
                React.createElement("header", { className: styles.title },
                    React.createElement("div", null, strings.option_ads_heading_allow_access),
                    React.createElement(Toggle, { checked: allowAccess, onChanged: actions.toggleAllowAccess })),
                React.createElement(OptionDescription, null, strings.option_ads_description_allow_access)),
            React.createElement("section", null,
                React.createElement("header", { className: styles.title },
                    React.createElement("div", null, strings.option_ads_heading_allow_personalization),
                    React.createElement(Toggle, { checked: allowPersonalization, onChanged: actions.toggleAllowPersonalization })),
                React.createElement(OptionDescription, null, strings.option_ads_description_allow_personalization)),
            React.createElement("section", null,
                React.createElement("header", { className: styles.title },
                    React.createElement("div", null, strings.option_ads_heading_allow_ad_selection),
                    React.createElement(Toggle, { checked: allowAdSelection, onChanged: actions.toggleAllowAdSelection })),
                React.createElement(OptionDescription, null, strings.option_ads_description_allow_ad_selection)),
            React.createElement("section", null,
                React.createElement("header", { className: styles.title },
                    React.createElement("div", null, strings.option_ads_heading_allow_content_selection),
                    React.createElement(Toggle, { checked: allowContentSelection, onChanged: actions.toggleAllowContentSelection })),
                React.createElement(OptionDescription, null, strings.option_ads_description_allow_content_selection)),
            React.createElement("section", null,
                React.createElement("header", { className: styles.title },
                    React.createElement("div", null, strings.option_ads_heading_allow_analytics),
                    React.createElement(Toggle, { checked: allowMeasurement, onChanged: actions.toggleAllowMeasurement })),
                React.createElement(OptionDescription, null, strings.option_ads_description_allow_analytics))));
    };
    AdvertisingOptionFull = tslib_1.__decorate([
        observer
    ], AdvertisingOptionFull);
    return AdvertisingOptionFull;
}(React.Component));
export default AdvertisingOptionFull;
//# sourceMappingURL=AdvertisingOptionFull.js.map